const formalWomen = [
  { title: "Blazers", icon: "icon1", subcategories: [] },
  { title: "Shirts", icon: "icon2", subcategories: [] },
  { title: "Dresses", icon: "icon2", subcategories: [] },
  { title: "Suits", icon: "icon2", subcategories: [] },
  { title: "Vests", icon: "icon2", subcategories: [] },
];
export default formalWomen;
